<template>
  <div v-if="!onlogin && !weconfig.is_logined()" class="home" style=" vertical-align: middle;margin:30% 30px;">
    <van-button  class="login-btn" type="info" block @click="login">微信授权登录</van-button>
  </div>
  <div v-else-if="!onlogin && weconfig.is_logined()" class="home" style=" vertical-align: middle;margin:10% 30px;">
    <div  style="display: flex;flex-direction:column;  justify-content: center;align-items: center">
      <van-icon name="checked" size="48" color="#1FC164"/>
      <div style="margin: 10px 0 30px 0;font-size: 20px;color: #2e2e2e">登录成功</div>
      <van-button  type="info" block @click="back">确认返回</van-button>
    </div>
  </div>
  <div v-else class="home" style=" vertical-align: middle;margin:30% 30px;">
    <div  style="text-align: center;font-size: 20px;color:#FF4D36">登录中...</div>
  </div>
</template>
<style>
</style>
<script>
  export default {
    name: 'welogin',
    data() {
      return {
        onlogin:false,
        active: 'index'
      }
    },
    created:function () {
      let params = this.weutil.getParams(window.location.href);
      if(Object.prototype.hasOwnProperty.call(params, "access_token")){
        this.onlogin = this.westore.state.user.token !== decodeURIComponent(params.access_token)
        if(this.westore.state.user.token !== decodeURIComponent(params.access_token)){
          this.westore.commit('setToken', decodeURIComponent(params.access_token))
          if(params.hasOwnProperty('redirect_name')){
            this.$router.push({ name: decodeURIComponent(params.redirect_name), params:params })
          }
          else{
            this.$router.push({name:this.werouter.index.name})
          }
        }
      }
      else if(params.hasOwnProperty('black')){
        this.$router.push({ name: this.werouter.black.name})
      }
      else if(params.hasOwnProperty('hidden')){
        this.$router.push({ name: this.werouter.error.name})
      }
    },
    methods:{
      login:function () {
        let redirectUrl =  this.weconfig.getRedirectUrl();
        let params = this.$route.query;
        params.redirect_uri = redirectUrl+ this.werouter.welogin.path;//this.weconfig.redirectUrl+'/welogin';
        params.bind_redirect_uri = redirectUrl+this.werouter.bindphone.path;//this.weconfig.redirectUrl+'/bindphone';
        params.app_id = this.westore.state.app.app_id;
        let paramsQuery = this.weutil.getQueryString(params);
        this.eventbus.$emit(this.weconfig.event.loginChanged, true);
        window.location.href = this.weconfig.requireUrl + '/wechat_login_page' + paramsQuery
      }
    }
  }
</script>
<style>
</style>
